module.exports = __webpack_public_path__ + "img/Topics-light.1f7faf11.svg";